module.exports = __webpack_public_path__ + "img/3a7d776.png";